var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app","data-app":""}},[_c('Header'),_c('telegram-banner'),_c('main',{staticClass:"main-app"},[_c('router-view')],1),_c('Footer',{staticClass:"footer-app"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }